.toolbar-container {
    position: absolute;
    top: -8px;
    right: 8px;
}

.email-progress-container {
    margin-bottom: -4px;
}
